<div class="row">
  <div class="col-12">
    <div class="agreements-button-container">
      <button class="btn btn-primary" (click)="openCreateAgreementModal()" translate>CREATE_AGREEMENT</button>
    </div>

    <h3 translate class="page-title text-left text-sm-center">PARTNER_AGREEMENTS</h3>
  </div>
</div>
<lib-filter-list [configService]="configService"></lib-filter-list>